(() => {
  const card = document.querySelector('[data-rose-counter]');
  if (!card) return;
  const amount = card.querySelector('[data-rose-amount]');
  const count = card.querySelector('[data-rose-count]');
  const euros = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
  async function refresh() {
    try {
      const response = await fetch(card.dataset.endpoint, { cache: 'no-store', mode: 'cors' });
      if (!response.ok) throw new Error('Compteur indisponible');
      const data = await response.json();
      if (!Number.isSafeInteger(data.amount_cents) || !Number.isSafeInteger(data.patch_count)) throw new Error('Données invalides');
      amount.textContent = euros.format(data.amount_cents / 100);
      count.textContent = `${data.patch_count} écusson${data.patch_count > 1 ? 's' : ''} pris en compte`;
    } catch (_) {
      amount.textContent = '—';
      count.textContent = 'Compteur momentanément indisponible';
    }
  }
  refresh();
  const timer = window.setInterval(refresh, 30000);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  window.addEventListener('pagehide', () => window.clearInterval(timer), { once: true });
})();
